<mat-form-field appearance="outline" [color]="isWarning ? 'warn' : isDisabled ? 'locked' : null" [floatLabel]="floatLabel">
  <mat-label>
    @if (teamStatusIcon) {
      <span class="teams-status-icon" [ngClass]="teamStatusIcon" role="img"></span>
    }
    {{ label }}
    <ng-content select="[inputLabelSuffix]"></ng-content>
  </mat-label>
  <nimbus-mat-drop-down
    [placeholder]="placeholder"
    #dropDownComponent
    [required]="isRequiredControl"
    [(ngModel)]="value"
    [disabled]="isDisabled"
    [panelClass]="panelClass"
    (openedChange)="onPanelToggle($event)"
    [errorStateMatcher]="this"
  >
    @if (selectedValue) {
      <nimbus-mat-drop-down-trigger [title]="selectedValue.name | translate">
        <div class="mat-option-item trigger" [class.disabled]="selectedValue.disabled">
          <div class="mat-option-text" [title]="selectedValue.name | translate">{{ selectedValue.name | translate }}</div>
          <div class="tooltip-container disabled-item-warning-icon">
            @if (selectedValue.isBeta) {
              <i class="disable-icon" [class.beta]="selectedValue.isBeta" [nimbusIcon]="icons.FLASK"></i>
            }
            @if (selectedValue.disabled || selectedValue.warningItemTooltip) {
              <i class="disable-icon" [nimbusIcon]="icons.WARNING"></i>
            }
            @if (selectedValue.disabled) {
              <nimbus-tooltip
                [text]="
                  selectedValue.disabledItemTooltip || disabledItemTooltipText || TranslationKeys.GeneralResourceCannotBeUsed | translate
                "
              ></nimbus-tooltip>
            }
            @if (selectedValue.warningItemTooltip && !selectedValue.disabled) {
              <nimbus-tooltip [text]="selectedValue.warningItemTooltip | translate"></nimbus-tooltip>
            }
          </div>
        </div>
      </nimbus-mat-drop-down-trigger>
    }
    @if (withSearch) {
      <mat-option class="mat-search-option">
        <nimbus-input-search
          class="search-container"
          #searchComponent
          [formControl]="searchInput"
          [placeholder]="TranslationKeys.GeneralTypeInToSearch | translate"
        >
        </nimbus-input-search>
      </mat-option>
    }
    @for (optionItem of options || []; track optionItem) {
      <mat-option
        [value]="optionItem.id"
        [disabled]="optionItem.disabled || optionItem.isGroup"
        [class.no-records]="optionItem.id === 'no_records'"
      >
        @if (!optionItem.disabled) {
          <div class="mat-option-item" [class.group]="optionItem.isGroup">
            @if (!optionItem.isGroup) {
              <div class="mat-option-text" [title]="optionItem[tooltipProp] | translate">{{ optionItem.name | translate }}</div>
              <div class="tooltip-container disabled-item-warning-icon">
                @if (optionItem.isBeta) {
                  <i class="disable-icon" [class.beta]="optionItem.isBeta" [nimbusIcon]="icons.FLASK"></i>
                }
                @if (!!optionItem.warningItemTooltip) {
                  <i class="disable-icon" [nimbusIcon]="icons.WARNING"></i>
                  <nimbus-tooltip [text]="optionItem.warningItemTooltip | translate"></nimbus-tooltip>
                }
              </div>
            } @else {
              <div class="group-dividers"></div>
              <div class="group-text" [title]="optionItem[tooltipProp] | translate">{{ optionItem.name | translate }}</div>
              <div class="group-dividers"></div>
            }
          </div>
        } @else {
          <div class="mat-option-item disabled" [class.no-records]="optionItem.id === 'no_records'">
            <div class="mat-option-text" [title]="optionItem[tooltipProp] | translate">{{ optionItem.name | translate }}</div>
            <div class="tooltip-container disabled-item-warning-icon">
              @if (optionItem.isBeta) {
                <i class="disable-icon" [class.beta]="optionItem.isBeta" [nimbusIcon]="icons.FLASK"></i>
              }
              <i class="disable-icon" [nimbusIcon]="icons.WARNING"></i>
              <nimbus-tooltip
                [text]="
                  optionItem.disabledItemTooltip || disabledItemTooltipText || TranslationKeys.GeneralResourceCannotBeUsed | translate
                "
              ></nimbus-tooltip>
            </div>
          </div>
        }
      </mat-option>
    }
  </nimbus-mat-drop-down>

  <ng-container matSuffix>
    <ng-content></ng-content>
  </ng-container>
  @if (!isDisabled && !isRequired && value) {
    <i matSuffix class="cursor-pointer" [nimbusIcon]="icons.CLOSE_LIGHT" (click)="onClearValueClick($event)"></i>
  }
  <i matSuffix class="cursor-pointer" [nimbusIcon]="icons.CHEVRON_DOWN_LIGHT"></i>
  @if (isDisabled) {
    <i matSuffix [nimbusIcon]="icons.LOCK_LIGHT"></i>
  }
  @if (ngControl && (ngControl.dirty || ngControl.touched) && ngControl.invalid) {
    <mat-error>
      <i [nimbusIcon]="icons.EXCLAMATION_TRIANGLE" class="error-triangle"></i>
      <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
    </mat-error>
  }
  @if (warningMessage && !(ngControl && (ngControl.dirty || ngControl.touched) && ngControl.invalid)) {
    <mat-hint align="start" [ngClass]="infoMessageStyle">
      <i [nimbusIcon]="messageIcon" class="error-triangle"></i>
      <nimbus-tooltip [text]="warningMessage"></nimbus-tooltip>
      <span class="hint-message">{{ warningMessage }}</span>
    </mat-hint>
  }
</mat-form-field>
